export const SpotGridColumnDefinitions = (dateFormat) => {
    return [
        {
            field: 'transmitterName',
            allowSorting: true,
            caption: window.translate('Log')
        },
        {
            field: 'id',
            allowSorting: true,
            type: 'string',
            visible: window.location?.href?.toLowerCase().indexOf('test.adserve') > -1,
            caption: window.translate('Id')
        },
        {
            field: 'displayDate',
            allowSorting: true,
            type: 'date',
            format: dateFormat,
            caption: window.translate('Date')
        },
        {
            field: 'spotTypeName',
            allowSorting: true,
            caption: window.translate('Spot Type'),
            visible: true
        },
        {
            field: 'breakDate',
            allowSorting: true,
            type: 'date',
            format: dateFormat,
            caption: window.translate('Scheduled Date'),
            visible: false
        },
        {
            field: 'dayPart',
            allowSorting: true,
            type: 'string',
            caption: window.translate('Daypart'),
            visible: true
        },
        {
            field: 'breakTime',
            allowSorting: true,
            caption: window.translate('Scheduled Time')
        },
        /*  {
            field: 'spotPrice',
            allowSorting: true,
            caption: window.translate('Spot Price')
        },
        */
        {
            field: 'actualTime',
            allowSorting: true,
            caption: window.translate('Broadcast Time')
        },
        {
            field: 'scriptLength',
            allowSorting: true,
            caption: window.translate('Length')
        },
        {
            field: 'actualDate',
            allowSorting: true,
            type: 'date',
            format: dateFormat,
            caption: window.translate('Playout Date'),
            visible: false
        },
        {
            field: 'positionInBreak',
            allowSorting: true,
            caption: window.translate('Position')
        },
        {
            field: 'scriptName',
            allowSorting: true,
            caption: window.translate('Script')
        },
        {
            field: 'cartNumber',
            allowSorting: true,
            caption: window.translate('Cart')
        },
        {
            field: 'baseImpacts',
            allowSorting: true,
            type: 'number',
            format: '#0.00',
            caption: window.translate('Base Impacts')
        },
        {
            field: 'targetImpacts',
            allowSorting: true,
            type: 'number',
            format: '#0.00',
            caption: window.translate('Target Impacts')
        }
    ];
};
